<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";

  const dispatch = createEventDispatcher<{
    click: undefined;
    dragStart: undefined;
    dragEnd: undefined;
    files: File[];
  }>();

  const preventDefaults = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrag = (e: DragEvent, dragging: boolean) => {
    preventDefaults(e);
    dispatch(dragging ? "dragStart" : "dragEnd");
  };

  const handleDrop = (e: DragEvent) => {
    preventDefaults(e);
    let dt = e.dataTransfer;
    if (!dt) return;
    let files = dt.files;
    handleFiles(files);
  };

  const handleFiles = (files: FileList) => {
    const pdfFiles: File[] = [];
    for (let i = 0; i < files.length; i++) {
      if (files[i].type === "application/pdf") {
        pdfFiles.push(files[i]);
      }
    }
    dispatch("files", pdfFiles);
  };

  const onDragStart = () => dispatch("dragStart");
  const onDragEnd = () => dispatch("dragEnd");
  const onClick = () => dispatch("click");

  let dropArea: HTMLButtonElement;

  onMount(() => {
    (["dragenter", "dragover"] as const).forEach((eventName) => {
      dropArea.addEventListener(eventName, (e) => handleDrag(e, true), false);
    });

    (["dragleave", "drop"] as const).forEach((eventName) => {
      dropArea.addEventListener(eventName, (e) => handleDrag(e, false), false);
    });

    dropArea.addEventListener("drop", handleDrop, false);
  });
</script>

<button
  class="file-trigger"
  on:click={onClick}
  on:mouseenter={onDragStart}
  on:mouseleave={onDragEnd}
  bind:this={dropArea}
>
  <slot />
</button>

<style>
  .file-trigger {
    width: 100%;
  }
</style>
